import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button, Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

Modal.setAppElement('body');

const FilterDropdown = ({
  children,
  defaultTitle,
  filterOptions,
  activeOptions,
  dropdownOpen,
  setDropdownOpen,
  className,
  isMobile,
}) => {
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const filterActive =
    dropdownOpen || (activeOptions && activeOptions.length !== 0);

  let title = defaultTitle;
  if (activeOptions.length === 1) {
    title = activeOptions[0].display;
  } else if (activeOptions.length > 1) {
    title = `${defaultTitle} (${activeOptions.length})`;
  }

  return (
    <>
      {isMobile ? (
        <>
          <Button
            className={cx('btn-rounded filter-toggle text-uppercase', {
              'filter-active': filterActive,
            })}
            onClick={toggle}
            data-testid={`filter-toggle-${defaultTitle}`}
            title={title}
          >
            {title}
          </Button>
          <Modal
            isOpen={dropdownOpen}
            className="full-screen-modal"
            shouldCloseOnOverlayClick={false}
            onRequestClose={toggle}
            closeTimeoutMS={250}
          >
            <div data-testid={`filter-modal-${defaultTitle}`}>
              <div className="filter-modal-header d-flex align-items-center justify-content-center">
                <Button
                  onClick={toggle}
                  color="link"
                  className="filter-modal-back-btn"
                >
                  <FontAwesomeIcon icon={faArrowLeft} />
                </Button>
                <h4 className="mb-0">{defaultTitle}</h4>
              </div>
              {children}
            </div>
          </Modal>
        </>
      ) : (
        <Dropdown isOpen={dropdownOpen} toggle={toggle} className={className}>
          <DropdownToggle
            className={cx('btn-rounded filter-toggle text-uppercase', {
              'filter-active': filterActive,
            })}
            data-testid={`filter-toggle-${defaultTitle}`}
            title={title}
          >
            {title}
          </DropdownToggle>
          {/** desktop dropdown**/}
          <DropdownMenu
            className="filter-dropdown py-0 my-0"
            style={{ minWidth: '15rem' }}
            data-testid={`filter-menu-${defaultTitle}`}
          >
            {children}
          </DropdownMenu>
        </Dropdown>
      )}
    </>
  );
};

FilterDropdown.propTypes = {
  activeOptions: PropTypes.array,
  children: PropTypes.node,
  className: PropTypes.string,
  defaultTitle: PropTypes.string,
  dropdownOpen: PropTypes.bool,
  filterOptions: PropTypes.array,
  setDropdownOpen: PropTypes.func,
};

export default FilterDropdown;
